// extracted by mini-css-extract-plugin
export var expandedRowWrapper = "_1j-6";
export var headerCell = "_1j-2";
export var rowWrapper = "_1j-4";
export var stickyAggregationCell = "_1j-a";
export var stickyAggregationRow = "_1j-7";
export var stickyColumnCell = "_1j-9";
export var stickyColumnHeaderCell = "_1j-8";
export var table = "_1j-1";
export var virtualRowWrapper = "_1j-5";
export var virtualTableContainer = "_1j-0";
export var white = "_1j-3";